export const DOCUMENT_SNIPPETS = [
  {
    id: "confidential",
    label: "Confidentiality line",
    hint: "Footer / cover",
    body: "\n\n---\n\n*Confidential — for the intended recipient only. Not for redistribution.*\n\n",
  },
  {
    id: "next-steps",
    label: "Next steps",
    hint: "Numbered list",
    body: "\n\n## Next steps\n\n1. …\n2. …\n3. …\n\n",
  },
  {
    id: "assumptions",
    label: "Assumptions",
    hint: "Bullet list",
    body: "\n\n**Assumptions**\n\n- …\n- …\n\n",
  },
  {
    id: "signature",
    label: "Sign-off block",
    hint: "Name / role / date",
    body: "\n\n---\n\n**Approved by:**\n\nName: …  \nRole: …  \nDate: …  \n\n",
  },
  {
    id: "placeholders",
    label: "Meta placeholders",
    hint: "{{CLIENT}} …",
    body: "\n\n**Client:** {{CLIENT}}  \n**Document:** {{TITLE}}  \n**Date:** {{DATE}}  \n**Version:** {{VERSION}}  \n\n",
  },
  {
    id: "pagebreak",
    label: "Print page break",
    hint: "PDF / print only",
    body: '\n\n<div class="print-page-break" aria-hidden="true"></div>\n\n',
  },
];
